import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { buildSiteDiscoveryLinks } from '../../utils/seoDiscovery.js';

const PageDiscoveryLinks = ({ markdownPath = '', language = 'en' }) => {
  const links = buildSiteDiscoveryLinks({ markdownPath, language });

  return (
    <Helmet>
      <meta name="application-name" content="Stocktag" />
      <meta name="apple-mobile-web-app-title" content="Stocktag" />
      <meta name="format-detection" content="telephone=no" />
      {links.map((link) => (
        <link
          key={`${link.rel}-${link.type}-${link.href}`}
          rel={link.rel}
          type={link.type}
          title={link.title}
          href={link.href}
        />
      ))}
    </Helmet>
  );
};

PageDiscoveryLinks.propTypes = {
  markdownPath: PropTypes.string,
  language: PropTypes.string
};

export default PageDiscoveryLinks;
